import { render, staticRenderFns } from "./GrapesJS.vue?vue&type=template&id=f9d7c16e&"
import script from "./GrapesJS.vue?vue&type=script&lang=js&"
export * from "./GrapesJS.vue?vue&type=script&lang=js&"
import style0 from "./GrapesJS.vue?vue&type=style&index=0&id=f9d7c16e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports